<template>
    <div style="max-height: 200px; overflow-y: auto;">
        <div v-for="(message, index) in comments" :key="index">
            <Message :message="message" :emojis="emojis" @reply="getMessage" @select="selectEmoji"/>
        </div>
    </div>
    <div class="reply_style mt-3" v-if="message?.content">
        <div class="d-flex justify-content-end">
            <i class="fas fa-times me-5 mt-2" @click="closeReply"></i>
        </div>
        <div class="d-flex align-items-center">
            <ManyAvatar :size="1" :data="commentator"/>
            <div class="ms-5 mb-2" v-html="message?.content"></div>
        </div>
    </div>
    <div class="d-flex align-items-center bg-white w-100 position-relative comment_style">
        <div class="d-flex align-items-center w-100 bg-white h-100">
            <div class="w-100">
                <textarea
                    v-model="formComment.content"
                    :class="{ 'form-control': true }"
                    :placeholder="$t('chat.writeMessage')"
                    class="form-control" rows="1"
                    @input="onInputChange"
                ></textarea>
                <ul v-if="suggestions.length > 0" class="suggestions-list shadow-sm">
                    <li class="badge badge-light-primary" v-for="(suggestion, index) in suggestions" :key="index" @click="addMention(suggestion)">
                        {{ suggestion.name }}
                    </li>
                </ul>
            </div>
        </div>
        <a @click.prevent="sendComment" class="btn btn-primary btn-icon mx-1">
            <i class="la la-send-o fs-2"></i>
        </a>
    </div>
</template>

<script setup>
    import {useStore} from "vuex";
    import {computed, ref, onMounted} from "vue";
    import { useI18n } from 'vue-i18n'
    import Message from "./Message.vue"
    import ManyAvatar from "@/components/ManyAvatar";

    const store = useStore()
    const { t } = useI18n({ useScope: 'global' })

    const props = defineProps({
        emojis: {
            type: Array,
            default: []
        },
        project: {
            type: Object,
            default: {}
        },
        detail: {
            type: Object,
            default: {}
        },
    })

    const formComment = ref({
        comment: '',
        mention_ids: []
    })
    const message = ref({})
    const suggestions = ref([])

    const comments = computed(() => store.getters["feeds/getComments"])
   
    const users = computed(() => {
        let filterProject = props.project
        let data = []
        if(filterProject){
            filterProject.users?.filter((item) => {
                data.push({
                    id: item.id,
                    name: item.lastname + ' ' + item.firstname
                })
            })
        }
        return data
    })
    const commentator = computed(() => {
        let fullname = message.value?.commentator?.fullname?.split(' ')
        return fullname ? [{firstname: fullname[0], lastname: fullname[1]}] : []
    })

    function loadComments() {
        if(props.detail?.id) store.dispatch('feeds/loadFeedComments', props.detail?.id)
    }

    function sendComment(){
        let action = Object.keys(message.value).length !== 0 ? 'feeds/replyFeedComment' : 'feeds/createFeedComment'
        store
            .dispatch(action, {publication_id: props.detail?.id, comment_id: message.value?.id, ...formComment.value})
            .then(() => {
                window.toastr["success"](t('feed.comment_successfully'));
                loadComments()
                formComment.value.content = ""
                formComment.value.mention_ids = []
                message.value = {}
            })
            .catch((e) => {

            });
    }

    function onInputChange() {
        const content = formComment.value.content;
        const lastChar = content[content.length - 1];

        if (lastChar === '@') {
            suggestions.value = users.value;
            return;
        }

        const mentionMatch = content.match(/[@#](\w*)$/);
        if (mentionMatch && mentionMatch[1]) {
            const searchQuery = mentionMatch[1].toLowerCase();
            if (content.includes('@')) {
                suggestions.value = users.value.filter(user => user.name.toLowerCase().includes(searchQuery));
            }
        } else {
            suggestions.value = [];
        }
    }

    function addMention(mention) {
        const content = formComment.value.content;
        const mentionSymbol = content.includes('@') ? '@' : '#';
        const startIdx = content.lastIndexOf(mentionSymbol);

        formComment.value.content = content.slice(0, startIdx) + mentionSymbol + mention.name + ' ';
        formComment.value.mention_ids.push(mention.id)
        suggestions.value = [];
    }

    function getMessage(msg) {
        message.value = msg
    }

    function closeReply() {
        message.value = {}
    }

    function selectEmoji(item, message_id) {
        store.dispatch('feeds/createFeedReaction', { type: item, model: "COMMENT", model_id: message_id }).then(() => {
            loadComments()
        })
    }

    onMounted(() => {
        loadComments()
    })
</script>

<style scoped>
    .comment_style {
        max-height: 200px; 
        height: auto; 
        min-height: 50px; 
    }
    .reply_style {
        border-top: 2px solid var(--bs-gray-200); 
        border-left: 2px solid var(--bs-gray-200); 
        border-right: 2px solid var(--bs-gray-200); 
        border-top-left-radius: 10px; 
        border-top-right-radius: 10px;
        padding-left: 10px;
    }
    .suggestions-list {
        list-style-type: none;
        padding: 0;
        margin: 0;
        position: absolute;
        background-color: #fff;
        border: 1px solid #fff;
        width: 100%;
        max-height: 150px;
        overflow-y: auto;
        z-index: 10;
        border-radius: 5px;
    }

    .suggestions-list li {
        padding: 8px;
        cursor: pointer;
    }

    .suggestions-list li:hover {
        background-color: #f0f0f0;
    }
</style>